<!--Implementação na View
    Componente:
    <auth-pin ref="pinComponent"></auth-pin>
    Botão:
    <b-button v-b-modal.ID-HERE @click="pinFoco()"></b-button>
-->
<template>
    <b-modal id="pin-modal" title="Informe seu PIN" centered hide-footer>
        <div class="spinner-border text-primary" style="display:none;" role="status" id="auth-spinner">
            <span class="sr-only">Aguarde...</span>
        </div>
        <div class="alert alert-info" id="auth-success" style="display:none;"></div>
        <div v-show="error" class="alert alert-danger" style="display:none;">{{ error }}</div>
        <div class="row" id="auth-form">
            <div class="col-12 mt-3 mb-3">
                <div class="input-group">
                    <input type="text" ref="authPin" id="authPin" v-model="pin" @keyup="pinKeyUp" name="authPin"
                        maxlength="4" autocomplete="off" class="form-control text-center"
                        style="text-security:disc; -webkit-text-security:disc;">
                    <span class="input-group-text">
                        <i class="bi bi-key-fill"></i>
                    </span>
                </div>
            </div>
        </div>
    </b-modal>
</template>

<script>
export default {

    data: function () {
        return {
            pin: '',
            error: false,
        }
    },

    mounted() {
        console.log('auth.pin loaded');
    },

    methods: {

        pinFoco() {
            $('#authPin').focus();
        },

        pinKeyUp(event) {
            this.error = false;
            if (event.key == 'Enter') {
                return false;
            }
            if (this.pin.length == 4) {
                return this.pinRequest();
            }
        },

        pinRequest() {
            axios
                .get(`/ajax/user/get-by-pin?pin=${this.pin}`)
                .then(response => (this.pinResponse(response.data)))
                .catch(error => console.log(error))
        },

        pinResponse(user) {
            this.pin = '';
            if (user) {
                this.$bvModal.hide('pin-modal');
                return this.$parent.pinResponse(user);
            }
            this.error = 'Pin não corresponde a nenhum usuário';
            setTimeout(this.pinFoco, 200);
        },
    }
};
</script>
